import type ISettingsJson from "@/types/ISettingsJson.ts";
import {useSystemAlertStore} from "@/app/system-alert/stores/useSystemAlertStore.ts";
import {useAppStore} from "@/stores/useAppStore.ts";

function isValidUrl(url: string): boolean {
  try {
    const parsed = new URL(url)
    return ['http:', 'https:'].includes(parsed.protocol)
  } catch {
    return false
  }
}

export async function loadSettings() {

  try {
    const res = await fetch('/settings.json', {
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!res.ok) {
      useSystemAlertStore().addError({
        message: `Failed to load settings: ${res.status} ${res.statusText}`,
        type: 'error',
      })
    }

    const contentType = res.headers.get("Content-Type") || "";
    if (!contentType.includes("application/json")) {
      useSystemAlertStore().addError({
        message: `Invalid content type. Expected application/json`,
        type: 'error',
      })

    }

    const settings: ISettingsJson = await res.json()

    if (isValidUrl(settings.admin_api_url)) {
      useAppStore().setAdminApiUrl( settings.admin_api_url)
    } else {
      useSystemAlertStore().addError({
        message: 'Invalid admin_api_url',
        type: 'error',
      })
      console.error('Invalid admin_api_url')
    }

  } catch (error) {
    useSystemAlertStore().addError({
      message: 'Error loading settings',
      type: 'error',
    })
    console.error('Error loading settings:', error)
  }


}
